module.exports = __webpack_public_path__ + "img/time_line_diamond.3c76e34f.svg";